/**
 * 웍스 연결(메일·일정) 실패 사유 코드 → 화면 문장 (v2.232.0 · 점검 ③ G-10)
 *
 * 왜 코드인가
 *   전에는 서버가 실패 문장을 주소(`/mypage?mail=error&msg=…`)에 실어 보냈고 화면이 그 글자를 그대로 띄웠다.
 *   그러면 **누구나 그런 주소를 만들어 포털 화면에 아무 문장이나 띄울 수 있었다**(「비밀번호를 다시 입력하세요」 같은 낚시 문구).
 *   이제 서버는 아래 코드만 넘기고, 화면은 코드에 맞는 **정해진 문장만** 보인다. 모르는 코드·옛 `msg` 는 무시한다.
 *   서버 쪽 코드: backend routes/mail/index.ts · routes/calendar/index.ts 의 `/oauth/callback`.
 */
const REASON_TEXT: Record<string, string> = {
  cancelled: '연결이 취소됐습니다.',
  nw_error: '네이버웍스가 연결을 거절했습니다. 잠시 뒤 다시 시도해 주세요.',
  params: '네이버웍스에서 돌아온 정보가 빠져 있습니다. 마이페이지에서 다시 시도해 주세요.',
  oauth: '연결 요청을 처리하지 못했습니다 — 요청이 만료됐거나 이미 처리됐거나, 이 웍스 계정이 다른 포털 사용자에게 연결돼 있을 수 있습니다. 마이페이지에서 다시 시도하고, 계속되면 관리자에게 알려 주세요.',
  upstream: '네이버웍스 응답을 처리하지 못했습니다. 잠시 뒤 다시 시도해 주세요.',
  config: '포털에 웍스 연결 설정이 아직 없습니다. 관리자에게 문의해 주세요.',
  server: '연결 처리 중 오류가 났습니다. 다시 시도해 주세요.',
};

export function oauthFailText(reason: string | null): string {
  return (reason && REASON_TEXT[reason]) || '연결에 실패했습니다. 다시 시도해 주세요.';
}
